import { format, parseISO } from 'date-fns';

export function getTransactionType(transaction) {
  const credit = Number(transaction?.credit || 0);
  return credit > 0 ? 'income' : 'expense';
}

export function getTransactionAmount(transaction) {
  const credit = Number(transaction?.credit || 0);
  return credit > 0 ? credit : Number(transaction?.debit || 0);
}

export function groupTransactionsByDate(transactions = []) {
  return transactions.reduce((groups, transaction) => {
    const label = format(parseISO(transaction.date), 'dd MMMM yyyy');
    if (!groups[label]) groups[label] = [];
    groups[label].push(transaction);
    return groups;
  }, {});
}
